import React, { useCallback, useEffect, useState } from "react";
import { EmblaCarouselType } from "embla-carousel";
import { IconButton, IconButtonProps, useTheme } from "@mui/material";
import { ArrowSplideLeft, ArrowSplideRight } from "../../../icons";

type usePrevNextHeroButtonsProps = {
  prevBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPrevButtonClick: () => void;
  onNextButtonClick: () => void;
};

export const usePrevNextHeroButtons = (
  emblaApi: EmblaCarouselType | undefined
): usePrevNextHeroButtonsProps => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};
type PropType = IconButtonProps;

export const PrevHeroButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;
  const theme = useTheme();
  return (
    <IconButton
      className="embla__button__hero embla__button--prev"
      type="button"
      {...restProps}
    >
      <ArrowSplideLeft
        sx={{
          width: { xs: "15px !important", md: "13px !important" },
          height: { xs: "15px !important", md: "13px !important" },
        }}
          htmlColor={theme.palette.secondary[500]}
      />
    </IconButton>
  );
};

export const NextHeroButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;
  const theme = useTheme();
  return (
    <IconButton
      className="embla__button__hero embla__button--next"
      type="button"
      {...restProps}
    >
      <ArrowSplideRight
        sx={{
          width: { xs: "15px !important", md: "13px !important" },
          height: { xs: "15px !important", md: "13px !important" },
        }}
        htmlColor={theme.palette.secondary[500]}
      />
    </IconButton>
  );
};
